
export const ComplianceGridError = () => (
	<div
		className="rounded-md border border-red-200 bg-red-50 p-6 text-sm text-red-700"
		data-testid="compliance-grid-error"
	>
		Failed to load compliance grid. Please try again.
	</div>
);
